import { IConfirmCartResult } from "../Models/order";

// Where a checkout attempt should land. A freshly created order goes to the payment page; a
// duplicate submission of the same cart already resolved with the gateway, so the customer is
// sent to that order's status page instead of being asked to pay a second time.
export function checkoutPath(res: IConfirmCartResult): string {
  if (res.created) {
    return `/payment/${res.orderId}`;
  }
  return `/ordering/order-status/${res.orderId}/${
    res.alreadyPaid ? "success" : "processing"
  }`;
}
